import React, { useState } from 'react';
import { CheckCircle2Icon, DownloadIcon, Loader2Icon } from 'lucide-react';
const checklistItems = ['Stucco cracks to seal before monsoon season', 'Signs of a hidden leak behind drywall', 'Garage door checks for 110° summers', 'The 5-minute paint touch-up schedule'];
export function ChecklistMagnet() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'done' | 'error'>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    window.setTimeout(() => setStatus('done'), 900);
  };
  return <section aria-labelledby="checklist-title" className="bg-white pb-20 lg:pb-28" data-id="element-53" data-mp="5raoc0g1nays">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-54" data-mp="2bjz6rwnm2dmo">
        <div className="grid overflow-hidden rounded-2xl bg-ink lg:grid-cols-[1fr_1fr]" data-id="element-55" data-mp="2bmlepxeeyv5f">
          <div className="p-8 sm:p-12" data-id="element-56" data-mp="27kqekw87ynt8">
            <p className="font-display text-lg font-bold uppercase text-brand" data-id="element-57" data-mp="2xzibpzwboxpk">Free download</p>
            <h2 id="checklist-title" className="mt-2 font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-58" data-mp="32y20e82awnlm">
              The Las Vegas Home Maintenance Checklist
            </h2>
            <p className="mt-4 text-white/75" data-id="element-59" data-mp="3comvhlirn9zs">
              A season-by-season guide built for desert homes. Catch small problems before they become expensive
              repairs.
            </p>

            {status === 'done' ? <div className="mt-7 flex items-start gap-3 rounded-xl bg-white/5 p-5 ring-1 ring-white/10" role="status" data-id="element-60" data-mp="3lni5l8oxl48d">
                <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-61" data-mp="3qltb57870sks" />
                <p className="text-white" data-id="element-62" data-mp="3vm7iso5vu0ia">
                  <strong className="font-display text-xl" data-id="element-63" data-mp="1waekmo7cyp3z">Check your inbox.</strong>
                  <span className="block text-sm text-white/70" data-id="element-64" data-mp="218y50k6azsu8">Your checklist is on its way to {email}.</span>
                </p>
              </div> : <form onSubmit={submit} noValidate className="mt-7" data-id="element-65" data-mp="1t8juydudda81">
                <div className="flex flex-col gap-3 sm:flex-row" data-id="element-66" data-mp="1p7q6njd0ltem">
                  <label className="flex-1" data-id="element-67" data-mp="2366ejdmm5pyc">
                    <span className="sr-only" data-id="element-68" data-mp="2380z2qtz3g1w">Email address</span>
                    <input type="email" autoComplete="email" placeholder="you@email.com" value={email} onChange={e => {
                  setEmail(e.target.value);
                  if (status === 'error') setStatus('idle');
                }} className="w-full rounded-lg border border-white/15 bg-white/5 px-4 py-3.5 text-white outline-none transition-colors duration-150 placeholder:text-white/40 focus:border-brand focus:ring-2 focus:ring-brand/30" data-id="element-69" data-mp="1y6to6iwja0r0" />
                  </label>
                  <button type="submit" disabled={status === 'submitting'} className="flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-brand px-6 py-3.5 font-display text-xl font-bold text-white transition-colors duration-150 hover:bg-brand-dark disabled:opacity-80" data-id="element-70" data-mp="2qxv7mw79eigc">
                    {status === 'submitting' ? <Loader2Icon className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-71" data-mp="2qtuv5tg87cht" /> : <DownloadIcon className="h-5 w-5" aria-hidden="true" data-id="element-72" data-mp="2vkbajj3lx86t" />}
                    Send My Checklist
                  </button>
                </div>
                {status === 'error' && <p className="mt-2 text-sm font-medium text-red-400" role="alert" data-id="element-73" data-mp="2mtawumjx22u3">
                    Please enter a valid email address.
                  </p>}
              </form>}
          </div>

          <div className="border-t border-white/10 bg-ink-soft p-8 sm:p-12 lg:border-l lg:border-t-0" data-id="element-74" data-mp="2cta9mpixf2km">
            <p className="font-display text-lg font-bold uppercase text-white/60" data-id="element-75" data-mp="3g46d98il6ut9">Inside the guide</p>
            <ul className="mt-5 divide-y divide-white/10" data-id="element-76" data-mp="3b7zd5wcvgdj8">
              {checklistItems.map(item => <li key={item} className="flex items-center gap-3 py-4 text-lg font-medium text-white" data-id="element-77" data-mp="36cthw6xkxmih">
                  <span className="grid h-6 w-6 shrink-0 place-items-center rounded border-2 border-brand" aria-hidden="true" data-id="element-78" data-mp="31e8puushe954" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}